import { createStore } from 'vuex';
import additionalFeaturesModal from './modules/additional-features-modal';
import features from './modules/features';
import specializedModals from './modules/specialized-modals';
import cart from './modules/cart';
import orderType from './modules/order-type';
import language from './modules/language';
import orders from './modules/orders';
import { persistencePlugin } from './plugins/persistence';
export default createStore({
    modules: {
        additionalFeaturesModal,
        features,
        specializedModals,
        cart,
        orderType,
        language,
        orders
    },
    plugins: [persistencePlugin]
});
